import Vue from 'vue'
import App from './App.vue'
import router from "@/router/router.js";
import store from "@/store";
import * as VueGoogleMaps from 'vue2-google-maps';
import VueCookies from "vue-cookies";
import VueTheMask from 'vue-the-mask';
import ThemesColors from "@/mixins/theme.js";
import '@babel/polyfill';
import { GMAPKEY } from './utils/functions';
import vuetify from './plugins/vuetify';
import VueGtm from '@gtm-support/vue2-gtm';
import { installCanalVentaDataLayer } from '@/utils/salesChannel';
// Vue.config.devtools = false;




Vue.use(VueGoogleMaps, 
{
  load: 
  {
    key:GMAPKEY
  }
});

Vue.use(VueCookies);
Vue.use(VueTheMask);
Vue.mixin(ThemesColors)
Vue.config.productionTip = false

// Solo en los builds de produccion (build-prod y build-prodgcp). El contenedor trae el pixel
// de Meta de produccion y la Conversions API Gateway que Meta tiene configurada reenvia por
// servidor todo lo que ve el navegador: cargado en UAT o en local, las pruebas terminaban
// como eventos reales. Fuera de produccion los dataLayer.push se siguen haciendo, asi que
// se pueden revisar en window.dataLayer sin mandar nada.
Vue.use(VueGtm, {
  id: 'GTM-KZWCJDQJ',
  enabled: process.env.NODE_ENV === 'production',
  vueRouter: router,
  debug: process.env.NODE_ENV !== 'production',
});

Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

installCanalVentaDataLayer(store);

new Vue({
  vuetify,
  router,
  store,
   created() {
    const qs = new URLSearchParams(window.location.search);
  const isAssisted = qs.has('session');
  const hasPromotorLogin = Boolean(VueCookies.get('codPromotor') && VueCookies.get('promotorName'));

  if (hasPromotorLogin && !isAssisted) {
    this.$store.commit('Conecta/setPromotor');
  }
  },
  render: h => h(App)
}).$mount('#app')
